import { Box, styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';

const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

const FieldBox = styled(Box)({ minWidth: 160 });

const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3)
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(5)
}));

const StyledDataGrid = styled(DataGrid)(() => ({
  ...dataGridSx(pallet),
  '& .MuiDataGrid-virtualScroller': {
    overflowX: 'auto',
    overflowY: 'auto'
  },
  '& .elective-cell-changed': {
    position: 'relative'
  },
  '& .elective-cell-changed:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    right: 0,
    width: 0,
    height: 0,
    borderTop: `12px solid ${pallet.primary} `,
    borderLeft: '12px solid transparent',
    zIndex: 2
  }
}));

const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  width: '100%'
}));

export {
  FiltersContainer,
  FieldBox,
  PageContainer,
  ButtonBox,
  HeaderWrapper,
  StyledDataGrid
};
